<template>
  <wo-card :title="title">
    <slot name="actions" slot="actions" />
    <po-table v-if="hasSalesPoints">
      <po-table-header :columns="tableColumns" slot="header" />
      <template slot="body">
        <tr v-for="item in salesPoints.items" :key="item.id">
          <td><po-route-link :value="getRoute(item)" :label="item.company.name" /></td>
          <td><po-display :value="item.channel" />&nbsp;(<po-display :value="item.audience" />)</td>
          <td><span v-if="item.company.address">{{ item.company.address.shortName }}</span></td>
        </tr>
      </template>
    </po-table>
    <po-empty-state v-else-if="salesPoints" />
    <po-paging v-model="currentPage" :data="salesPoints" />
  </wo-card>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import filtered from '@/mixins/filtered'

import { companySalesPointRepository } from '@/repository/sales-point'
import { Company } from '@/model/company'

import { SALES_POINT } from '@/routes/sales-point'

export default {
  mixins: [filtered],
  props: {
    filter: Object,
    titleKey: { type: String, default: 'salespointList.matching' },
    company: Company
  },
  computed: mapState({
    salesPoints: state => state.salesPoint.companySalesPointList,
    hasSalesPoints () {
      return this.salesPoints && !_.isEmpty(this.salesPoints.items)
    },
    title () {
      const title = this.$t(this.titleKey)
      const count = this.hasSalesPoints && this.salesPoints.total_count
      return this.salesPoints ? `${title} (${count})` : title
    },
    tableColumns () {
      return [
        { labelKey: 'company.name' },
        { labelKey: 'salespoint.channel' },
        { labelKey: 'company.address' }
      ]
    },
    resultMessage () {
      if (this.salesPoints) {
        const key = this.hasOverflow ? 'salespointMap.firstMatches' : 'salespointMap.allMatches'
        return this.$tc(key, this.salesPoints.count, { totalCount: this.salesPoints.total_count })
      }
    }
  }),
  methods: {
    applyFilter (filter, pristine) {
      return this.$store.dispatch(companySalesPointRepository.findAll, { companyId: this.company.id, filter: filter, replace: !pristine })
    },
    getRoute (salesPoint) {
      return {
        name: SALES_POINT,
        params: { salesPointId: salesPoint.id }
      }
    }
  }
}
</script>
